import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { useUserPlan } from '../context/UserPlanContext';
import { F, DUR, EASE } from '../styles/theme';
import { RedWordmark, planSub } from './red/Brand';
import { Icon, Icons } from './red/Icons';
import { useUI } from '../context/ThemeContext';
import NotificationBell from './NotificationBell';
import { usePress } from './red/Press';

export default function TopBar({ onBack, backTitle, unread = 0, hideRight = false, customLeft, onOpenAlerts, onOpenMarkets, bare = false }) {
  const { T } = useTheme();
  const ui = useUI();
  const { plan } = useUserPlan();
  const sub = planSub(plan);
  const backPress = usePress({ scale: 0.92 });
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: bare ? 'calc(env(safe-area-inset-top, 0px) + 8px) 18px 6px' : '60px 18px 14px',
        background: bare ? 'transparent' : T.navBg,
        backdropFilter: bare ? 'none' : T.navBlur,
        WebkitBackdropFilter: bare ? 'none' : T.navBlur,
        borderBottom: bare ? 'none' : `1px solid ${T.navBorder}`,
        // bare = KEINE Bar: schwebt (reserviert keinen Platz → Inhalt durchgehend
        // bis ganz oben) und liegt unter Sheets/Nav, damit nie ein Header hinter
        // einem offenen Menü „aufleuchtet".
        position: bare ? 'absolute' : 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: bare ? 5 : 10,
        pointerEvents: bare ? 'none' : 'auto',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {customLeft ? (
          customLeft
        ) : onBack ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button
              onClick={onBack}
              {...backPress.pressHandlers}
              style={{
                width: ui.touch.icon,
                height: ui.touch.icon,
                borderRadius: ui.radius.control,
                transform: backPress.pressTransform,
                transition: `transform ${DUR.fast}ms ${EASE}`,
                // Randlos: nur das Chevron, keine Glass-Box (wie die Header-Icons).
                background: 'transparent',
                border: 'none',
                boxShadow: 'none',
                cursor: 'pointer',
                color: T.text,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                WebkitTapHighlightColor: 'transparent',
                padding: 0,
                flexShrink: 0,
                marginLeft: -6,
                pointerEvents: 'auto',
              }}
            >
              <Icon d={Icons.back} size={22} stroke={T.text} sw={2.2} />
            </button>
            {backTitle && (
              <span style={{
                fontFamily: F.family,
                fontSize: 17,
                fontWeight: 700,
                letterSpacing: '-0.02em',
                color: T.text,
                lineHeight: 1,
              }}>{backTitle}</span>
            )}
          </div>
        ) : bare ? (
          <span />
        ) : (
          <RedWordmark sub={sub} size={22} />
        )}
      </div>
      {!hideRight && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 2, pointerEvents: 'auto' }}>
          {/* Märkte nur noch per Wisch-Geste (Dashboard → rechts) — kein Icon mehr.
              Sprache + Theme nur unter Profil. */}
          <NotificationBell variant="circle" onManage={onOpenAlerts} />
        </div>
      )}
    </div>
  );
}
